<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-28 09:53:52
 * @FilePath: \YunYin_admin\src\views\Setting\BusinessArea\components\leftTree.vue
-->
<template>
  <div class="left-tree">
    <div class="left-header">
      <el-input
        placeholder="搜索成员和区域"
        v-model.trim="keyWord"
        @keyup.enter.native="handleFilter"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" class="filter-btn" @click="handleFilter"
        >查询</el-button
      >
      <el-button
        type="primary"
        plain
        icon="el-icon-plus"
        class="btn-add"
        @click="addArea()"
        >添加区域</el-button
      >
    </div>
    <div class="tree-content">
      <el-tree
        ref="my-tree"
        :data="businessZoneList"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        :current-node-key="currentId"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="zone-name" :title="data.zoneName">{{
            data.zoneName
          }}</span>
          <span>
            <el-dropdown trigger="click">
              <i class="el-dropdown-link el-icon-more"> </i>
              <el-dropdown-menu slot="dropdown" class="area-dropdown">
                <el-dropdown-item
                  v-for="item in handles"
                  :key="item.id"
                  v-show="hideDropdown(data, item, node)"
                  :class="{ 'hide-border': hideBorder(data, item, node) }"
                  @click.native="handleNode(node, data, item)"
                  >{{ item.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </span>
      </el-tree>
    </div>
    <CurrentDialog
      v-if="showDialog"
      :showDialog="showDialog"
      :dialogObj="dialogObj"
      :areaData="areaData"
      :businessZoneList="businessZoneList"
      :multipleSelection="[]"
      @handleNodeClick="handleNodeClick"
      @close="close"
      @getBusinessZoneList="getBusinessZoneList"
    ></CurrentDialog>
  </div>
</template>

<script>
import CurrentDialog from "./CurrentDialog";
export default {
  name: "LeftTree",
  data() {
    return {
      keyWord: "", // 搜索关键字
      businessZoneList: [], // 业务区域树
      // tree more 按钮数据
      handles: [
        { label: "添加子区域", id: 2, w: "400px", btn: "保存" },
        { label: "修改名称", id: 3, w: "400px", btn: "保存" },
        { label: "设置负责人", id: 4, w: "500px", btn: "确认" },
        { label: "删除", id: 5, w: "400px", btn: "删除" },
        { label: "上移", id: 6 },
        { label: "下移", id: 7 },
      ],
      currentId: null, // 当前选中nodekey
      showDialog: false, // 弹框显示
      dialogObj: {}, // 弹框类型
      areaData: {}, // 当前点击区域
    };
  },
  components: { CurrentDialog },
  computed: {
    hideDropdown() {
      return (data, item, node) => {
        let flag = true;
        switch (item.id) {
          case 6:
            flag = data.orderNum !== 1;
            break;
          case 7:
            if (node.level == 1) {
              flag = data.orderNum != node.parent.data.length;
            } else {
              flag = data.orderNum != node.parent.data.children.length;
            }
            break;
          default:
            break;
        }
        return flag;
      };
    },
    hideBorder() {
      return (data, item, node) => {
        let flag = false;
        if (item.id == 6) {
          if (node.level == 1) {
            flag = data.orderNum == node.parent.data.length;
          } else {
            flag = data.orderNum == node.parent.data.children.length;
          }
        }
        if (item.id == 5) {
          if (node.level == 1) {
            flag =
              data.orderNum == node.parent.data.length && data.orderNum == 1;
          } else {
            flag =
              data.orderNum == node.parent.data.children.length &&
              data.orderNum == 1;
          }
        }
        return flag;
      };
    },
  },
  methods: {
    /**
     * @description:搜索成员和区域
     * @Author: yangsibo
     * @Date: 2022-05-12 09:32:23
     */
    handleFilter() {
      this.$refs["my-tree"].filter(this.keyWord);
    },
    /**
     * @description: 添加区域
     * @Author: yangsibo
     * @Date: 2022-05-12 09:35:22
     */
    addArea() {
      this.dialogObj = { label: "添加区域", w: "400px", id: 1, btn: "保存" };
      this.showDialog = true;
    },
    /**
     * @description: 获取业务区域树
     * @Author: yangsibo
     * @Date: 2022-05-12 10:20:36
     */
    async getBusinessZoneList(callback) {
      try {
        let { data } = await this.$http.common.getBusinessZoneList();
        data.forEach((item) => {
          item.level = 1;
        });
        this.businessZoneList = data;
        callback && callback();
      } catch (error) {}
    },
    /**
     * @description: 树形结构更多按钮操作
     * @Author: yangsibo
     * @Date: 2022-05-12 14:06:41
     * @param {*} node
     * @param {*} data
     * @param {*} id
     */
    handleNode(node, data, item) {
      if (item.id < 6) {
        this.dialogObj = item;
        this.areaData = data;
        this.areaData.orderNum = data.children ? data.children.length + 1 : 1;
        this.showDialog = true;
      } else {
        let switchLevel = item.id == 6 ? 1 : 0;
        this.switchOrder(data.id, switchLevel);
      }
    },
    /**
     * @description: 上移下移
     * @Author: yangsibo
     * @Date: 2022-05-12 18:12:12
     * @param {*} id 操作类型
     * @return {*}
     */
    async switchOrder(id, switchLevel) {
      try {
        let { status } = await this.$http.business.switchOrder({
          id,
          switchLevel,
        });
        if (status === "1") {
          this.$message({
            type: "success",
            message: `${switchLevel ? "上移" : "下移"}成功`,
            duration: 2000,
          });
          this.getBusinessZoneList(() => {
            this.$nextTick(() => {
              this.$refs["my-tree"].setCurrentKey(this.currentId);
            });
          });
        }
      } catch (error) {}
    },
    /**
     * @description: 点击树形结构节点
     * @Author: yangsibo
     * @Date: 2022-05-12 14:08:53
     * @param {*} data 当前点击的节点
     */
    handleNodeClick(data) {
      this.setCurrentId(data);
    },
    /**
     * @description: 设置currentId
     * @Author: yangsibo
     * @Date: 2022-05-12 14:25:47
     */
    setCurrentId(data) {
      this.$emit("getCurrentId", data);
    },
    /**
     * @description: tree搜索回调
     * @Author: yangsibo
     * @Date: 2022-05-12 17:29:02
     * @param {String} value 搜索关键字
     * @param {Object} data 节点数据
     * @return {Boolean} 是否过滤
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.zoneName.indexOf(value) !== -1;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
  },
  created() {
    this.getBusinessZoneList(() => {
      this.$nextTick(() => {
        const { zoneName, id } = this.businessZoneList[0];
        this.currentId = id;
        this.$refs["my-tree"].setCurrentKey(this.currentId);
        this.setCurrentId({ zoneName, id });
      });
    });
  },
  mounted() {},
};
</script>
<style lang="scss">
.area-dropdown {
  .el-dropdown-menu__item {
    text-align: center;
    border-bottom: 1px solid #e6f2f2;
    &.hide-border {
      border: none;
    }
    &:nth-child(6) {
      border: none;
    }
  }
}
</style>
<style lang="scss" scoped>
.left-tree {
  height: 100%;
  .left-header {
    width: 100%;
    display: flex;
    .el-input {
      width: 220px;
      height: 40px;
      background: #ffffff;
      border-radius: 3px;
      min-width: 100px;
    }
    .filter-btn {
      width: 74px;
      height: 40px;
      margin: 0 12px;
      border-radius: 3px;
    }
    .btn-add {
      width: 108px;
      height: 40px;
      border-radius: 3px;
      margin: 0;
      padding: 10px;
    }
    margin-bottom: 10px;
  }
  .tree-content {
    max-height: calc(100% - 50px);
    overflow: auto;
    ::v-deep .el-tree-node.is-current > .el-tree-node__content {
      background: #e1f4f5;
      .custom-tree-node {
        color: #018388;
        .el-icon-more {
          color: #018388;
        }
      }
    }
    ::v-deep .el-tree-node:focus > .el-tree-node__content {
      background: #e1f4f5;
    }
    ::v-deep .el-tree-node__content {
      height: 40px;
      .el-tree-node__expand-icon.expanded,
      .el-icon-caret-right {
        font-size: 16px;
        color: #404040;
      }
      .el-tree-node__expand-icon.is-leaf {
        color: transparent;
        cursor: default;
      }
      &:hover {
        background: #e1f4f5;
        .custom-tree-node {
          color: #018388;
          .el-icon-more {
            color: #018388;
          }
        }
      }
      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        color: #222222;
        padding-right: 8px;
        max-width: 91%;
        .zone-name {
          max-width: 98%;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .el-icon-more {
          transform: rotate(90deg);
          color: #a0a6a6;
        }
      }
    }
  }
}
</style>
